import React from "react";
import { useNavigate } from "react-router-dom";

import PropTypes from "prop-types";
function Header(props) {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/");
  };

  return (
    <header>
      <div className="container-lg">
        <button onClick={handleClick}>
          <img
            src={props.path}
            alt="ICICI Bank Logo"
            width={298}
            height={58}
            className="img-fluid logo"
          />
        </button>
      </div>
    </header>
  );
}

Header.propTypes = {
  path: PropTypes.string,
};

export default Header;
